import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"

// Icon imports
import DashboardIcon from "../../../assets/icons/iconComponents/dashboardIcon"
import ProjectManagementIcon from "../../../assets/icons/iconComponents/projectManagementIcon"
import EstimateIcon from "../../../assets/icons/iconComponents/estimateIcon"
import ProductMasterIcon from "../../../assets/icons/iconComponents/productMasterIcon"
import ProcurementIcon from "../../../assets/icons/iconComponents/procurementIcon"
import HrmsIcon from "../../../assets/icons/iconComponents/hrmsIcon"
import SettingsIcon from "../../../assets/icons/iconComponents/settingsIcon"
import FinanceIcon from "../../../assets/icons/iconComponents/financeIcon"
import CentralStoreIcon from "../../../assets/icons/iconComponents/centralStoreIcon"

const iconMap = {
  dashImg: DashboardIcon,
  projectImg: ProjectManagementIcon,
  estimateImg: EstimateIcon,
  productMasterImg: ProductMasterIcon,
  procureImg: ProcurementIcon,
  hrmsImg: HrmsIcon,
  settingsImg: SettingsIcon,
  financeImg: FinanceIcon,
  centralStoreImg: CentralStoreIcon,
}

const formatLabel = key =>
  key
    .replace(/([A-Z])/g, " $1")
    .replace(/[_-]/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase())

const IconDropdown = ({
  control,
  name,
  onSelectChange,
  placeholder,
  disabled = false,
  target,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [iconOptions, setIconOptions] = useState([])

  const loadOptions = () => {
    const options = Object.entries(iconMap).map(([key, Icon]) => ({
      label: (
        <div className="dropdown-icon-label">
          <Icon size={18} className="me-2" />
          {formatLabel(key)}
        </div>
      ),
      value: key,
      rawLabel: formatLabel(key),
      icon: Icon,
    }))
    setIconOptions(options)
    setIsLoading(false)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ref, value } }) => (
        <Select
          ref={ref}
          options={iconOptions}
          isLoading={isLoading}
          isDisabled={disabled}
          value={iconOptions.find(
            opt => opt.value === value?.value || opt.value === value
          )}
          onChange={e => {
            onChange(e?.value)
            if (onSelectChange) onSelectChange(e)
          }}
          placeholder={
            <div className="css-placeholder">
              {placeholder || "Select Icon"}
            </div>
          }
          classNamePrefix="react-select"
          className="elevate-dropdown"
          noOptionsMessage={() => "No icons found"}
          menuPortalTarget={document.querySelector(target || "body")}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        />
      )}
    />
  )
}

export default IconDropdown
